export const roadenam = [
    {
        id: 0,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "Obstetricia🤰",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "CELPIP TASK 1 TO 8 ",
        enlaces: [
            {  titulo:"PDF Materiales",url: "https://drive.google.com/file/d/1oMYmaaEhXh28Vm-S0mxPzVWOSW-eS5Sy/view?usp=sharing"},        

            {  titulo:"Introduccion",url: "https://drive.google.com/file/d/1_QHmsFPDb6X_7B4JRzlzT16LCcSwTZ92/view?usp=sharing"},        
            {  titulo:"Hemorragias de la l mitad del embarazo parte 1",url: "https://drive.google.com/file/d/17QuZsf9pDZmUPc57vSSCZnrBvIJjuTF7/view?usp=sharing"},        
            {  titulo:"Hemorragias de la l mitad del embarazo parte 2.",url: "https://drive.google.com/file/d/1FykIUMHcGDgfoZpqw5w12ImYyHL103qn/view?usp=sharing"},        

            {  titulo:"Hemorragias de la ll mitad del embarazo",url: "https://drive.google.com/file/d/13E4RLgdCZZfu358K9_MMyvDLiS7Z0g0o/view?usp=sharing"},        
            {  titulo:"Hemorragias posparto",url: "https://drive.google.com/file/d/1N7ohWqHiW3PJJPZ9keCHj3C94iCQxzEX/view?usp=sharing"},        
            {  titulo:"Trastornos hipertensivos",url: "https://drive.google.com/file/d/1HMSPEs3r7dawKOSVbvtQ6GGicuokDhb7/view?usp=sharing"},        
            {  titulo:"Propedéutica y control prenatal",url: "https://drive.google.com/file/d/1my5ClZ1Hl3TWrizhypKzf0uobsAkjfzc/view?usp=sharing"},        

            {  titulo:"Parto normal",url: "https://drive.google.com/file/d/1EB22XXu774nfIrT-u6N2CbkL9kQo8ACT/view?usp=sharing"},        
            {  titulo:"Distocias",url: "https://drive.google.com/file/d/1wfl8gESKAP3HiaSrAQfNQrBLBLhTCqeT/view?usp=sharing"},        


            {  titulo:"Puerperio patológico",url: "https://drive.google.com/file/d/1ZwGZ35LCuMRuLmEeDVlLkzl-zJ_wpnVt/view?usp=sharing"},        
            {  titulo:"Preguntas y respuestas",url: "https://drive.google.com/file/d/1GIW7__mvS2vHJ53TBMaNtAjmal7oBLwP/view?usp=sharing"},        

        ],
    },
    
    {
        id: 14,
        thumbnail:
            "https://i.ibb.co/PZ6Srhv/level3.png",
        title: "Mix Clinicas Cardiologia",
        subtitle: "B2/C1",

        dateAdded: "B2/C1",
        channel: "sdasd",
        description: "Mejora tus habilidades de comprensión auditiva con este curso que te ayudará a entender a hablantes nativos en diferentes situaciones y acentos, fortaleciendo tu confianza al escuchar y comprender el idioma.",
        enlaces: [
           
            { titulo: "Cardiopatía isquémica", url: "https://drive.google.com/file/d/1MKkEnM6ABu8UmYtqmWdG6wEFbPnNHwIq/view?usp=sharing" },
            { titulo: " Arritmias", url: "https://drive.google.com/file/d/1zLZ9sYxQ9BLNEtLF391_VhItr8mrmCBX/view?usp=sharing" },

            
    
        ],
    },
    {
        id: 13,
        thumbnail:
            "https://i.ibb.co/yfYMBBS/level2.png",
        title: "Speaking Center",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [
            {
                titulo: "🖥️ Speaking Simulation",
                url: "https://drive.google.com/file/d/1QhvhLsCjF6V1BaYqpSd3cV9lgNuOCw_h/view?usp=sharing",
            },
            {
                titulo: "🖥️ Speaking Trainer 01",
                url: "https://drive.google.com/file/d/1n-sf1L6DJZKdj0GSGV2zlPlaYI4WhJQ9/view?usp=sharing",
            },
            {
                titulo: "🖥️Speaking Trainer 02",
                url: "https://drive.google.com/file/d/1Jiwqspyx05GE1Br1tTir8j-xWm1_-VbG/view?usp=sharing",
            },
            {
                titulo: "📒 speaking Part 1-2-3-4",
                url: "https://docs.google.com/presentation/d/1Q7V5Ww0BAerQrYrVNFck7nU9YapznQql/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },
            {
                titulo: "🎯speaking Part 1",
                url: "https://wordwall.net/play/519/287/727",
            },
            {
                titulo: "📒 Linking Words | B2 First (FCE)",
                url: "https://docs.google.com/presentation/d/1B6PtmwOv-DQxTW4SpPQQ7iPhUH_d8Lxy/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },
            {
                titulo: "📒 10 Preguntas de examen – Speaking Parte 1 (Entrevista) | B2 First (FCE)",
                url: "https://docs.google.com/document/d/1kXkFOi-IFJP83_QTg6SZNKGfiSpI5IFXAlcTJmgwkJE/edit",
            },
            {
                titulo: "📒 Speaking Part 1 - Useful Phrases",
                url: "https://docs.google.com/document/d/18XLLq6gRiQqTNU4iIiI0qzc6epBd8hBQ/edit",
            },
            {
                titulo: "📒 Speaking Part 2 - Useful Phrases",
                url: "https://docs.google.com/presentation/d/1nl85F1o3_TfrK04XJk1Z_rkA6E_T9h7q/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒 Speaking Part 3 - Useful Phrases",
                url: "https://docs.google.com/document/d/1uNFaRWS_kuBKwQtr5L6vf3vTwcejt-B7/edit",
            },
            {
                titulo: "📒Speaking Part 4 - Useful Phrases",
                url: "https://docs.google.com/document/d/1uNFaRWS_kuBKwQtr5L6vf3vTwcejt-B7/edit",
            },
            
            
        ],
    },
   

    
];
